import type { TealiumEventData } from 'src/types/trackingData';

const CONCIERGE_SUBMIT_EVENT = 'concierge-submit';
export const conciergeSubmitEvent: TealiumEventData = {
  linkName: CONCIERGE_SUBMIT_EVENT,
  eventName: [CONCIERGE_SUBMIT_EVENT],
};

const CONCIERGE_SUBMIT_SUCCESS_EVENT = 'concierge-submit-success';
export const conciergeSubmitSuccessEvent: TealiumEventData = {
  linkName: CONCIERGE_SUBMIT_SUCCESS_EVENT,
  eventName: [CONCIERGE_SUBMIT_SUCCESS_EVENT],
};

const CONCIERGE_SUBMIT_FAILED_EVENT = 'concierge-submit-failed';
export const conciergeSubmitFailedEvent: TealiumEventData = {
  linkName: CONCIERGE_SUBMIT_FAILED_EVENT,
  eventName: [CONCIERGE_SUBMIT_FAILED_EVENT],
};

const GUARANTEED_HIRE_SUBMIT_EVENT = 'guaranteed-hire-submit';
export const guaranteedHireSubmitEvent: TealiumEventData = {
  linkName: GUARANTEED_HIRE_SUBMIT_EVENT,
  eventName: [GUARANTEED_HIRE_SUBMIT_EVENT],
};

const GUARANTEED_HIRE_SUBMIT_SUCCESS_EVENT = 'guaranteed-hire-submit-success';
export const guaranteedHireSubmitSuccessEvent: TealiumEventData = {
  linkName: GUARANTEED_HIRE_SUBMIT_SUCCESS_EVENT,
  eventName: [GUARANTEED_HIRE_SUBMIT_SUCCESS_EVENT],
};

const GUARANTEED_HIRE_SUBMIT_FAILED_EVENT = 'guaranteed-hire-submit-failed';
export const guaranteedHireSubmitFailedEvent: TealiumEventData = {
  linkName: GUARANTEED_HIRE_SUBMIT_FAILED_EVENT,
  eventName: [GUARANTEED_HIRE_SUBMIT_FAILED_EVENT],
};

const PREMIUM_PLUS_SUBMIT_EVENT = 'premium-plus-submit';
export const premiumPlusSubmitEvent: TealiumEventData = {
  linkName: PREMIUM_PLUS_SUBMIT_EVENT,
  eventName: [PREMIUM_PLUS_SUBMIT_EVENT],
};

const PREMIUM_PLUS_SUBMIT_SUCCESS_EVENT = 'premium-plus-submit-success';
export const premiumPlusSubmitSuccessEvent: TealiumEventData = {
  linkName: PREMIUM_PLUS_SUBMIT_SUCCESS_EVENT,
  eventName: [PREMIUM_PLUS_SUBMIT_SUCCESS_EVENT],
};

const PREMIUM_PLUS_SUBMIT_FAILED_EVENT = 'premium-plus-submit-failed';
export const premiumPlusSubmitFailedEvent: TealiumEventData = {
  linkName: PREMIUM_PLUS_SUBMIT_FAILED_EVENT,
  eventName: [PREMIUM_PLUS_SUBMIT_FAILED_EVENT],
};
